import { IEntity } from "./Entity";
import { IUser } from "./User";
import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";
import { IRiskAppIssue } from "./RiskAppIssue";
import { IEntityContributors } from "./EntityContributors";

export interface IRiskAppIssueAction extends IEntityWithStatus, IEntityContributors {

    IssueID?: number;
    Description?: string;
    ActionOwnerID?: number;
    ActualStartDate?: Date | null;
    TargetCompletionDate?: Date | null;
    StageID?: number;
    EntityCreatedOn?: Date | null;
    EntityModifiedOn?: Date | null;
    ActionOwner?: IUser;
    Issue?: IRiskAppIssue;
    Stage?: IEntity;
}

export class RiskAppIssueAction extends EntityWithStatus implements IRiskAppIssueAction {

    public IssueID = null;
    public Description = null;
    public ActionOwnerID = null;
    public ActualStartDate = null;
    public TargetCompletionDate = null;
    public StageID = null;
    public EntityCreatedOn = null;
    public EntityModifiedOn = null;
    public Contributors = [];

}
